import { get } from "../common/http.services";

export function getAllProducts(searchText: any, isCosting: any,  pageNumber: any,  pageSize: any, appContext: any, success: any, error: any) {
    return get(`/product?searchText=${searchText}&isCosting=${isCosting}&page=${pageNumber}&size=${pageSize}&sort=category,product,asc`, appContext, success, error);
}
